import React, { useCallback, useEffect, useState, useRef } from 'react';
import { X } from 'lucide-react';
interface Product {
  name: string;
  price: string;
}
const products: Product[] = [{
  name: 'Sistema Completo',
  price: '$12.95'
}, {
  name: 'Recetas Airfryer',
  price: '$9.95'
}, {
  name: 'Acceso Total',
  price: '$29.95'
}];
// Female names paired with female-looking pravatar IDs
const femaleProfiles = [{
  name: 'María',
  avatarId: 1
}, {
  name: 'Laura',
  avatarId: 5
}, {
  name: 'Ana',
  avatarId: 9
}, {
  name: 'Sofía',
  avatarId: 10
}, {
  name: 'Valentina',
  avatarId: 16
}, {
  name: 'Camila',
  avatarId: 20
}, {
  name: 'Isabella',
  avatarId: 23
}, {
  name: 'Lucía',
  avatarId: 24
}, {
  name: 'Daniela',
  avatarId: 26
}, {
  name: 'Paula',
  avatarId: 29
}, {
  name: 'Gabriela',
  avatarId: 32
}, {
  name: 'Martina',
  avatarId: 44
}, {
  name: 'Carolina',
  avatarId: 47
}, {
  name: 'Natalia',
  avatarId: 25
}];
// Male names paired with male-looking pravatar IDs
const maleProfiles = [{
  name: 'Carlos',
  avatarId: 12
}, {
  name: 'Luis',
  avatarId: 15
}, {
  name: 'Diego',
  avatarId: 33
}, {
  name: 'Javier',
  avatarId: 51
}, {
  name: 'Miguel',
  avatarId: 52
}, {
  name: 'Andrés',
  avatarId: 53
}, {
  name: 'Roberto',
  avatarId: 59
}, {
  name: 'Fernando',
  avatarId: 60
}, {
  name: 'Sebastián',
  avatarId: 61
}, {
  name: 'Alejandro',
  avatarId: 62
}, {
  name: 'Ricardo',
  avatarId: 63
}, {
  name: 'Mateo',
  avatarId: 64
}, {
  name: 'Tomás',
  avatarId: 68
}, {
  name: 'Eduardo',
  avatarId: 14
}];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function PurchaseNotifications() {
  const [notification, setNotification] = useState<{
    name: string;
    product: Product;
    avatarId: number;
  } | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const hideTimerRef = useRef<ReturnType<typeof setTimeout>>();
  const nextTimerRef = useRef<ReturnType<typeof setTimeout>>();
  const showNotification = useCallback(() => {
    const pool = Math.random() > 0.5 ? femaleProfiles : maleProfiles;
    const profile = getRandomItem(pool);
    const product = getRandomItem(products);
    setNotification({
      name: profile.name,
      product,
      avatarId: profile.avatarId
    });
    setIsVisible(true);
    // Hide after 3–5 seconds
    const hideDuration = 3000 + Math.random() * 2000;
    hideTimerRef.current = setTimeout(() => {
      setIsVisible(false);
    }, hideDuration);
    // Schedule next notification after 6–12 seconds
    const nextDelay = 6000 + Math.random() * 6000;
    nextTimerRef.current = setTimeout(() => {
      showNotification();
    }, nextDelay);
  }, []);
  useEffect(() => {
    // First notification after 4 seconds
    const initialTimer = setTimeout(showNotification, 4000);
    return () => {
      clearTimeout(initialTimer);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
      if (nextTimerRef.current) clearTimeout(nextTimerRef.current);
    };
  }, [showNotification]);
  const handleClose = () => {
    setIsVisible(false);
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
  };
  if (!notification) return null;
  return <div className={`fixed bottom-6 left-4 z-50 transition-all duration-500 ease-out transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0 pointer-events-none'}`} data-id="element-190">
      <div className="bg-white rounded-xl shadow-[0_4px_24px_rgba(0,0,0,0.08)] px-3.5 py-3 max-w-[280px] relative border border-gray-100/80" data-id="element-191">
        <button onClick={handleClose} className="absolute top-2 right-2 text-gray-300 hover:text-gray-500 transition-colors" aria-label="Cerrar" data-id="element-192">
          <X className="w-3 h-3" data-id="element-193" />
        </button>

        <div className="flex items-center gap-3 pr-4" data-id="element-194">
          <div className="relative flex-shrink-0" data-id="element-195">
            <img src={`https://i.pravatar.cc/80?img=${notification.avatarId}`} alt="" className="w-9 h-9 rounded-full object-cover" data-id="element-196" />
            <div className="absolute -bottom-0.5 -right-0.5 bg-green-500 rounded-full w-2.5 h-2.5 border-[1.5px] border-white" data-id="element-197" />
          </div>

          <div className="flex-1 min-w-0" data-id="element-198">
            <p className="text-[13px] font-semibold text-gray-900 leading-tight truncate" data-id="element-199">
              {notification.name} compró {notification.product.name}
            </p>
            <p className="text-[11px] text-gray-400 mt-0.5" data-id="element-200">
              Hace unos segundos · {notification.product.price}
            </p>
          </div>
        </div>
      </div>
    </div>;
}